module.exports = __webpack_public_path__ + "img/id-card.39520daa.png";